import React, { useEffect, useRef, useState } from 'react';
import { db, auth } from '../firebase';
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  addDoc,
  where,
  getDocs,
  getDoc,
  doc,
  deleteDoc,
  serverTimestamp,
  setDoc,
  writeBatch,
  arrayUnion,
} from 'firebase/firestore';
import { supabase } from './supabaseClient';
import Filter from 'bad-words';
import { useRole } from './RoleContext';
import '../App.css';

function Chat({ setPage }) {
    // Emoji sidebar state
    const [emojiSidebar, setEmojiSidebar] = useState([]);
    const emojiList = ['😀','😂','😍','😎','🥳','👍','🙏','🎉','🔥','💯','😢','😡','🤔','👏','🙌','😱','🥰','🤩','😇','😜','😏'];

    // Animate emoji up the sidebar
    useEffect(() => {
      if (!emojiSidebar.length) return;
      const timer = setTimeout(() => {
        setEmojiSidebar(prev => prev.slice(1));
      }, 1800);
      return () => clearTimeout(timer);
    }, [emojiSidebar]);

    function handleSendEmoji(emoji) {
      setEmojiSidebar(prev => [...prev, { emoji, id: Date.now() }]);
      // Optionally: send emoji event to other users via Firestore for real-time sync
    }
  const { role } = useRole();
  const [userId, setUserId] = useState(null);
  const [acceptedChats, setAcceptedChats] = useState([]);
  const [currentChatID, setCurrentChatID] = useState(null);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [typingUsers, setTypingUsers] = useState({});
  const [canChat, setCanChat] = useState(false);
  const [roomName, setRoomName] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [userProfiles, setUserProfiles] = useState({});
  const [availability, setAvailability] = useState(false);
  const [chatDeleted, setChatDeleted] = useState(false);
  const chatEndRef = useRef(null);
  console.log(availability);

  const filter = new Filter();
  const customBadWords = [ 'fool', 'dumb', 'stupid', 'idiot', 'moron', 'loser', 'lame', 'jerk', 'suck', 'trash', 'crap', 'nonsense', 'damn', 'darn', 'heck', 'screw', 'lazy', 'worthless', 'failure', 'barf', 'gross', 'yuck', 'clown', 'pest', 'nut', 'whiny', 'annoying', 'silly', 'weird', 'pathetic', 'dummy', 'noob', 'poop', 'pee', 'wee', 'backstabber', 'blackmail', 'blacklist', 'idiotic', 'poopoo', 'peepee', 'weewee', 'troll', 'troller', 'trolling', 'trolled', 'breast', 'womp-womp', 'w-o-m-p-w-o-m-p', 'fuck', 'f*ck', 'fuk', 'fvck', 'f--k', 'stinks', 'womp', 'wompwomp', 'shit', 'sh1t', 'sh!t', 'sht', 'explode', 'explosion', 'exploded', 'evil', 'bad', 'angry', 'annoyed', 'annoying', 'annoy', 'angrier', 'destroy', 'bitch', 'b!tch', 'biatch', 'hate', 'hatred', 'loathe', 'despair', 'poopy', 'poo-poo', 'bastard', 'asshole', 'a**hole', 'azzhole', 'fool', 'dick', 'd1ck', 'd!ck', 'cock', 'c0ck', 'cawk', 'stinky', 'pussy', 'p*ssy', 'pussi', 'ugh', 'ass', 'butts', 'slut', 'sl*t', 'sloot', 'h0e', 'ugly', 'jackass', 'dumbass', 'c*nt', 'c*ntface', 'tits', 'titties', 'blowjob', 'bj', 'weed', 'marijuana', 'maryjane', 'ganja', 'bud', '420', 'dope', 'hash', 'blunt', 'joint', 'thc', 'delta8', 'delta9', 'cbd', 'bong', 'toke', 'cocaine', 'coke', 'freak', 'loser', 'peepee', 'weewee', 'wee-wee', 'pee-pee', 'crack', 'meth', 'pooping', 'weeing', 'poopratheadboy', 'poopratheadgirl', 'stinkyhead', 'stinkyboy', 'stinkygirl', 'heroin', 'smack', 'molly', 'mdma', 'ecstasy', 'lsd', 'acid', 'shrooms', 'mushrooms', 'ketamine', 'fentanyl', 'xanax', 'xanny', 'oxy', 'oxys', 'lean', 'sizzurp', 'roids', 'steroids', 'smooch', 'kiss', 'kissing', 'kissed', 'kisser', 'grope', 'groper', 'groped', 'groped', 'slap', 'stalk', 'stalker', 'stalking', 'stalked', '🤬', '😡', '👿', '💢', '🗯️', '💀', '🖕', '🗡️', '🔪', '😘','😗','😚','😙','😽','💋','👄','🍑','🍆', 'stab', 'kill', 'die', 'suicide', 'murder', 'cut', 'blood', 'punch', 'stabbed', 'stabbing', 'stabber', 'backstab', 'backstabbed', 'backstabber', 'kick', 'fūçk', 'sh¡t', 'b¡tch', 'püśśy', 'sĥit', 'cün†', 'bomb', 'bombs', 'bombed', 'bombing', 'knife', 'rekt', 'gitgud', 'ezclap', 'trashcan', 'reportyou', 'l2p', 'boobs', 'buttocks', 'butt', 'bombom', 'bumbum', 'yansh', 'naked', 'ihoho' ]; 
  filter.addWords(...customBadWords);
  // Scroll to bottom on new messages
  useEffect(() => {
    if (chatEndRef.current) {
      chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, currentChatID]);

  // Auth listener
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      if (user) setUserId(user.uid);
      else {
        setUserId(null);
        setAcceptedChats([]);
        setCurrentChatID(null);
        setMessages([]);
        setCanChat(false);
        setRoomName(null);
        setAvailability(false);
      }
    });
    return unsubscribe;
  }, []);

  // Fetch chats and user profiles
  useEffect(() => {
    if (!userId) return;

    async function fetchChats() {
      const mentorQ = query(
        collection(db, 'mentorRequests'),
        where('mentorId', '==', userId),
        where('status', '==', 'accepted')
      );
      const menteeQ = query(
        collection(db, 'mentorRequests'),
        where('requesterId', '==', userId),
        where('status', '==', 'accepted')
      );

      const [mSnap, rSnap] = await Promise.all([getDocs(mentorQ), getDocs(menteeQ)]);

      const chats = await Promise.all([
        ...mSnap.docs.map(async ds => {
          const d = ds.data();
          const menteeDocSnap = await getDoc(doc(db, 'users', d.requesterId));
          if (!menteeDocSnap.exists()) {
            await deleteDoc(doc(db, 'mentorRequests', ds.id));
            return null;
          }
          const menteeData = menteeDocSnap.data();
          const mentorUser = auth.currentUser;
          return {
            chatId: ds.id,
            mentorEmail: mentorUser.email,
            mentorName: mentorUser.fullName || 'You',
            menteeEmail: menteeData.email,
            menteeName: menteeData.fullName || 'You',
            menteeId: d.requesterId,
            mentorId: d.mentorId,
          };
        }),
        ...rSnap.docs.map(async ds => {
          const d = ds.data();
          const mentorDocSnap = await getDoc(doc(db, 'users', d.mentorId));
          if (!mentorDocSnap.exists()) {
            await deleteDoc(doc(db, 'mentorRequests', ds.id));
            return null;
          }
          const mentorData = mentorDocSnap.data();
          const menteeUser = auth.currentUser;
          return {
            chatId: ds.id,
            mentorEmail: mentorData.email,
            mentorName: mentorData.fullName || 'You',
            menteeEmail: menteeUser.email,
            menteeName: menteeUser.fullName || 'You',
            menteeId: userId,
            mentorId: d.mentorId,
          };
        }),
      ]);

      const only = chats.filter(Boolean);
      setAcceptedChats(only);

      if (only.length && !only.find(c => c.chatId === currentChatID)) {
        setCurrentChatID(only[0].chatId);
        const menteePrefix = only[0].menteeId.slice(0, 10);
        setRoomName(`${menteePrefix}-${only[0].chatId}`);
      }

      // Load profiles for display
      const profileUserIds = new Set();
      only.forEach(c => {
        profileUserIds.add(c.menteeId);
        profileUserIds.add(c.mentorId);
      });

      const profilesObj = {};
      for (const uid of profileUserIds) {
        const docSnap = await getDoc(doc(db, 'users', uid));
        if (docSnap.exists()) {
          const data = docSnap.data();
          let profileUrl = null;
          try {
            const { data: supaData } = supabase.storage
              .from('profile-pictures')
              .getPublicUrl(`profile-pictures/${uid}/profile.jpg`);
            profileUrl = supaData.publicUrl;
          } catch {}
          profilesObj[data.email] = {
            fullName: data.fullName || data.email,
            profileUrl,
          };
        }
      }
      setUserProfiles(profilesObj);
      setAvailability(true);
    }

    fetchChats();
    // eslint-disable-next-line
  }, [userId]);

  // Typing users effect
  useEffect(() => {
    if (!currentChatID || !userId) return;
    const typingRef = collection(db, 'chats', currentChatID, 'typing');
    const unsub = onSnapshot(typingRef, (snapshot) => {
      const data = {};
      snapshot.docs.forEach((doc) => {
        if (doc.id !== userId && doc.data().typing) {
          data[doc.id] = true;
        }
      });
      setTypingUsers(data);
    });
    return () => unsub();
  }, [currentChatID, userId]);

  // Typing indicator for current user
  useEffect(() => {
    if (!currentChatID || !userId) return;
    const typingRef = doc(db, 'chats', currentChatID, 'typing', userId);
    if (newMessage.trim()) {
      setDoc(typingRef, { typing: true, updatedAt: new Date() }, { merge: true });
    }
    const timeout = setTimeout(() => {
      setDoc(typingRef, { typing: false }, { merge: true });
    }, 3000);
    return () => clearTimeout(timeout);
  }, [newMessage, currentChatID, userId]);

  // Sync messages for current chat
  useEffect(() => {
    if (!currentChatID) {
      setMessages([]);
      setCanChat(false);
      return;
    }
    let unsub = onSnapshot(
      query(collection(db, 'chats', currentChatID, 'messages'), orderBy('timestamp', 'asc')),
      snap => {
        const formattedMessages = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setMessages(formattedMessages);

        // Mark as seen
        if (formattedMessages.length && currentChatID && userId) {
          const batch = writeBatch(db);
          formattedMessages.forEach((msg) => {
            if (!msg.seenBy?.includes(userId)) {
              const msgRef = doc(db, 'chats', currentChatID, 'messages', msg.id);
              batch.update(msgRef, {
                seenBy: arrayUnion(userId),
              });
            }
          });
          batch.commit();
        }
      },
      err => console.error(err)
    );

    (async () => {
      const docSnap = await getDoc(doc(db, 'mentorRequests', currentChatID));
      if (docSnap.exists()) {
        const d = docSnap.data();
        setCanChat(d.status === 'accepted' && (d.mentorId === userId || d.requesterId === userId));
        const menteePrefix = d.requesterId.slice(0, 10);
        setRoomName(`${menteePrefix}-${currentChatID}`);
      }
    })();

    return unsub;
  }, [currentChatID, userId]);

  async function sendMessage() {
    if (!canChat || (!newMessage.trim() && !imageFile)) return;
    let imageUrl = null;
    if (imageFile) {
      try {
        const fileName = `profile-${Date.now()}.jpg`;
        const filePath = `chat_images/${currentChatID}/${fileName}`;
        const { error: uploadError } = await supabase.storage
          .from('chat-images')
          .upload(filePath, imageFile);
        if (uploadError) throw uploadError;
        const { data: publicUrlData, error: urlError } = supabase.storage
          .from('chat-images')
          .getPublicUrl(filePath);
        if (urlError) throw urlError;
        imageUrl = publicUrlData.publicUrl;
      } catch (e) {
        console.error('Image upload failed:', e);
        alert('Image upload failed. Please try again.');
        return;
      }
    }
    try {
      const cleaned = filter.clean(newMessage.trim());
      await addDoc(collection(db, 'chats', currentChatID, 'messages'), {
        text: cleaned,
        sender: auth.currentUser.email,
        senderId: userId,
        timestamp: serverTimestamp(),
        imageUrl: imageUrl || null,
        seenBy: [userId],
      });
      setNewMessage('');
      setImageFile(null);
      setTimeout(() => {
        if (chatEndRef.current) {
          chatEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } catch (e) {
      console.error(e);
      alert("Failed to send message. Please make add more text for description.");
    }
  }

  function handleStartVideoCall() {
    if (!roomName) return;
    const meetURL = `https://meet.jit.si/${roomName}`;
    window.open(meetURL, '_blank');
  }

  return (
    <div style={{ display: 'flex', height: '80vh', background: '#f3f6fb', borderRadius: 16, boxShadow: '0 2px 16px rgba(0,0,0,0.07)', overflow: 'hidden', position: 'relative' }}>
      {/* Emoji sidebar (right side) */}
      <div style={{ position: 'absolute', right: 0, top: 0, height: '100%', width: 60, zIndex: 10, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'flex-end', pointerEvents: 'none' }}>
        {emojiSidebar.map((e, idx) => (
          <div key={e.id} style={{
            position: 'absolute',
            bottom: 24 + idx * 48,
            right: 12,
            fontSize: 36,
            opacity: 1 - idx * 0.2,
            transform: `translateY(-${idx * 48}px)`,
            transition: 'all 0.7s cubic-bezier(.4,0,.2,1)',
            filter: 'drop-shadow(0 2px 8px rgba(0,0,0,0.12))',
            pointerEvents: 'none',
          }}>{e.emoji}</div>
        ))}
      </div>
      {/* Sidebar for chat navigation */}
      <div style={{ width: 260, background: '#fff', borderRight: '1px solid #e5e7eb', padding: '24px 12px', display: 'flex', flexDirection: 'column', gap: 12 }}>
        <h2 style={{ marginBottom: 16, fontSize: 22, color: '#2563eb' }}>Chats</h2>
        {!acceptedChats.length ? (
          <p style={{ color: '#888' }}>No accepted chats yet.</p>
        ) : (
          acceptedChats.map(c => (
            <button
              key={c.chatId}
              onClick={() => {
                setCurrentChatID(c.chatId);
                const menteePrefix = c.menteeId.slice(0, 10);
                setRoomName(`${menteePrefix}-${c.chatId}`);
                setChatDeleted(false);
              }}
              style={{
                margin: '2px 0',
                padding: '12px 16px',
                background: c.chatId === currentChatID ? '#2563eb' : '#f3f6fb',
                color: c.chatId === currentChatID ? '#fff' : '#222',
                border: 'none',
                borderRadius: 8,
                fontWeight: 600,
                textAlign: 'left',
                cursor: 'pointer',
                boxShadow: c.chatId === currentChatID ? '0 2px 8px rgba(37,99,235,0.08)' : 'none'
              }}
            >
              <span style={{ fontSize: 15 }}>
                Mentor: {c.mentorName}<br />
                <span style={{ fontSize: 13, color: '#666' }}>Mentee: {c.menteeName}</span>
              </span>
            </button>
          ))
        )}
        <button
          onClick={() => setPage(role === 'mentor' ? 'mentorconnections' : 'menteeconnections')}
          style={{
            marginTop: 'auto',
            padding: '12px 16px',
            background: '#3498db',
            color: '#fff',
            border: 'none',
            borderRadius: 8,
            fontWeight: 600,
            cursor: 'pointer',
            boxShadow: '0 2px 8px rgba(52,152,219,0.08)'
          }}
        >
          Back to Your Connections
        </button>
      </div>

      {/* Main chat area */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', position: 'relative' }}>
        <div style={{ padding: '24px 32px 0 32px', flex: 1, overflowY: 'auto' }}>
          <h3 style={{ color: '#2563eb', marginBottom: 8 }}>Chat Room</h3>
          {currentChatID && !chatDeleted ? (
            <>
              {/* Typing indicator */}
              {!canChat && <p style={{ color: '#e11d48', fontWeight: 600 }}>Chat not accepted yet.</p>}
              {Object.keys(typingUsers).length > 0 && (
                <p style={{ fontStyle: 'italic', color: '#666', paddingLeft: '1rem' }}>
                  {Object.keys(typingUsers).length > 1
                    ? 'Several users are typing...'
                    : 'User is typing...'}
                </p>
              )}
              {/* Message list */}
              <div style={{ maxHeight: '48vh', overflowY: 'auto', padding: '8px 0', background: '#f8fafc', borderRadius: 12, border: '1px solid #e5e7eb', marginBottom: 8 }}>
                {!messages.length ? (
                  <p style={{ color: '#888', textAlign: 'center', marginTop: 32 }}>No messages yet.</p>
                ) : (
                  messages.map((m, i) => {
                    const profile = userProfiles[m.sender] || {};
                    const isMe = m.sender === auth.currentUser.email;
                    return (
                      <div
                        key={m.id}
                        style={{
                          display: 'flex',
                          flexDirection: isMe ? 'row-reverse' : 'row',
                          alignItems: 'flex-end',
                          marginBottom: 18,
                          gap: 10
                        }}
                      >
                        <img
                          src={profile.profileUrl || 'https://via.placeholder.com/36'}
                          alt="profile"
                          style={{
                            width: 36,
                            height: 36,
                            borderRadius: '50%',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                            margin: isMe ? '0 0 0 10px' : '0 10px 0 0'
                          }}
                          onError={e => {
                            e.target.style.display = 'none';
                          }}
                        />
                        <div style={{ maxWidth: '70%' }}>
                          <div
                            style={{
                              background: isMe ? 'linear-gradient(90deg,#2563eb 60%,#60a5fa 100%)' : '#fff',
                              color: isMe ? '#fff' : '#222',
                              padding: '10px 16px',
                              borderRadius: isMe ? '16px 16px 4px 16px' : '16px 16px 16px 4px',
                              marginBottom: 4,
                              boxShadow: '0 2px 8px rgba(0,0,0,0.04)'
                            }}
                          >
                            <span style={{ fontWeight: 600, fontSize: 15 }}>{profile.fullName || m.sender}</span>
                            {m.text && (
                              <p style={{ margin: '6px 0 0 0', fontSize: 15 }}>{m.text}</p>
                            )}
                            {m.imageUrl && (
                              <img
                                src={m.imageUrl}
                                alt="uploaded"
                                style={{
                                  maxWidth: 200,
                                  maxHeight: 200,
                                  marginTop: 8,
                                  borderRadius: 8,
                                  boxShadow: '0 2px 8px rgba(0,0,0,0.07)'
                                }}
                                onError={e => {
                                  e.target.style.display = 'none';
                                }}
                              />
                            )}
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 6 }}>
                              {auth.currentUser.email &&
                                m.seenBy?.length >= 2 && (
                                  <span style={{ fontSize: '12px', color: isMe ? '#dbeafe' : '#888' }}>✔✔ Seen</span>
                                )}
                              {auth.currentUser.email &&
                                m.seenBy?.length <= 1 && (
                                  <span style={{ fontSize: '12px', color: isMe ? '#dbeafe' : '#888' }}>✔ Sent</span>
                                )}
                            </div>
                          </div>
                          <span style={{ fontSize: 12, color: '#666', margin: '2px 0', display: 'block', textAlign: isMe ? 'right' : 'left' }}>
                            {m.timestamp?.toDate ? m.timestamp.toDate().toLocaleString() : ''}
                          </span>
                        </div>
                      </div>
                    );
                  })
                )}
                <div ref={chatEndRef} />
              </div>
              {/* Message input area */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
                <input
                  type="text"
                  value={newMessage}
                  onChange={e => setNewMessage(e.target.value)}
                  placeholder={canChat ? 'Type a message...' : 'Chat not available'}
                  disabled={!canChat}
                  onKeyDown={e => { if (e.key === 'Enter') sendMessage(); }}
                  style={{
                    flex: 1,
                    padding: '14px 16px',
                    fontSize: 16,
                    borderRadius: 12,
                    border: '1px solid #d0d7de',
                    background: canChat ? '#fff' : '#f3f4f6',
                    outline: 'none',
                    boxShadow: 'inset 0 1px 2px rgba(16,24,40,0.03)',
                    fontWeight: 500
                  }}
                />
                <input
                  id="chat-image"
                  type="file"
                  accept="image/*"
                  onChange={e => setImageFile(e.target.files[0])}
                  disabled={!canChat}
                  title="Upload an image!"
                  style={{ display: 'none' }}
                />
                <label
                  htmlFor="chat-image"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    padding: '10px 14px',
                    borderRadius: 10,
                    border: '1px solid #cbd5e1',
                    background: canChat ? '#fafafa' : '#eceff1',
                    color: '#0f172a',
                    cursor: canChat ? 'pointer' : 'not-allowed',
                    fontSize: 15,
                    minWidth: 110,
                    justifyContent: 'center',
                    fontWeight: 500
                  }}
                >
                  📎
                  <span style={{
                    maxWidth: 120,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}>
                    {imageFile ? imageFile.name : 'Attach image'}
                  </span>
                </label>
                <button
                  onClick={sendMessage}
                  disabled={!canChat}
                  style={{
                    padding: '12px 22px',
                    borderRadius: 12,
                    border: 'none',
                    background: canChat ? 'linear-gradient(90deg,#2563eb 60%,#60a5fa 100%)' : '#93c5fd',
                    color: '#fff',
                    fontWeight: 700,
                    fontSize: 16,
                    cursor: canChat ? 'pointer' : 'not-allowed',
                    boxShadow: canChat ? '0 6px 18px rgba(37,99,235,0.12)' : 'none'
                  }}
                >
                  Send
                </button>
              </div>
              {imageFile && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 12,
                  padding: 8,
                  borderRadius: 10,
                  border: '1px solid #eef2ff',
                  background: '#ffffff',
                  marginTop: 8
                }}>
                  <img
                    src={URL.createObjectURL(imageFile)}
                    alt="preview"
                    style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: 8, border: '1px solid #e6eef8' }}
                  />
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{imageFile.name}</div>
                    <div style={{ fontSize: 12, color: '#64748b' }}>{(imageFile.size / 1024).toFixed(1)} KB</div>
                  </div>
                  <button
                    onClick={() => setImageFile(null)}
                    style={{
                      marginLeft: 'auto',
                      padding: '6px 10px',
                      borderRadius: 8,
                      border: '1px solid #e2e8f0',
                      background: '#fff',
                      cursor: 'pointer',
                      fontWeight: 500
                    }}
                  >
                    Remove
                  </button>
                </div>
              )}
              {/* Controls: video call and emoji picker */}
              <div style={{ marginTop: 18, display: 'flex', gap: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
                <button
                  onClick={handleStartVideoCall}
                  disabled={!roomName}
                  style={{
                    padding: '12px 24px',
                    background: 'linear-gradient(90deg,#2563eb 60%,#60a5fa 100%)',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 12,
                    fontWeight: 700,
                    fontSize: 16,
                    cursor: roomName ? 'pointer' : 'not-allowed',
                    boxShadow: '0 2px 8px rgba(37,99,235,0.08)'
                  }}
                >
                  Start or Join Video Call
                </button>
                <div style={{ display: 'flex', gap: 4, alignItems: 'center', marginLeft: 12 }}>
                  {emojiList.map((emoji, idx) => (
                    <button
                      key={emoji}
                      onClick={() => handleSendEmoji(emoji)}
                      style={{
                        fontSize: 22,
                        background: 'none',
                        border: 'none',
                        cursor: 'pointer',
                        padding: 2,
                        transition: 'transform 0.1s',
                        margin: '0 2px',
                      }}
                      title={`Send ${emoji}`}
                    >{emoji}</button>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <p style={{ color: '#888', textAlign: 'center', marginTop: 32 }}>Select a chat to start messaging.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default Chat;

